import {
  Box,
  Grid,
  Typography,
  useTheme,
  IconButton,
  Modal,
  TextField,
  Button,
  MenuItem,
  Select,
} from '@mui/material';
import Swal from 'sweetalert2';
import { Delete } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../../components/Header';
import { tokens } from '../../theme';

const ViewDirector = () => {
  const { id } = useParams();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [user, setUser] = useState(null);
  const [open, setOpen] = useState(false);
  const [render, setRender] = useState(false);
  const [editField, setEditField] = useState({ field: '', value: '' });
  const token = localStorage.getItem('accessToken');

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axios.get(
          `https://webback.opencurtainscasting.com/director/getDirector/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setUser(response.data.user);
      } catch (error) {
        console.error('Error fetching the user data:', error);
      }
    };

    fetchUser();
  }, [id, token, render]);

  const handleEditClick = (
    api = 'director',
    apiField,
    field,
    value,
    type = 'text',
    options = []
  ) => {
    setEditField({ api, apiField, field, value, type, options });
    setOpen(true);
  };

  const handleSave = async () => {
    try {
      if (editField.field === 'imageURL') {
        const formData = new FormData();
        formData.append('imageURL', editField.value);

        const response = await axios.put(
          `https://webback.opencurtainscasting.com/${editField?.api}/updateUserImage/${id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          }
        );

        const updatedImageURL = response.data.imageURL;
        setUser((prevUser) => ({
          ...prevUser,
          result: {
            ...prevUser.result,
            imageURL: updatedImageURL,
          },
        }));
      } else if (editField.field === 'images') {
        const formData = new FormData();
        if (editField.value instanceof FileList) {
          for (let i = 0; i < editField.value.length; i++) {
            formData.append('images', editField.value[i]);
          }
        } else if (editField.value instanceof File) {
          formData.append('images', editField.value);
        }

        const response = await axios.put(
          `https://webback.opencurtainscasting.com/${editField?.api}/updateUserImages/${id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          }
        );

        const updatedImages = response.data.result?.updatedUser?.images || [];
        setUser((prevUser) => ({
          ...prevUser,
          result: {
            ...prevUser.result,
            images: updatedImages,
          },
        }));
      } else if (editField.field === 'fullName') {
        const [firstName, lastName] = editField.value.split(' ');
        await axios.put(
          `https://webback.opencurtainscasting.com/${editField?.api}/updateFirstName/${id}`,
          { firstName },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        await axios.put(
          `https://webback.opencurtainscasting.com/${editField?.api}/updateLastName/${id}`,
          { lastName },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setUser((prevUser) => ({
          ...prevUser,
          registerResult: {
            ...prevUser.registerResult,
            firstName,
            lastName,
          },
        }));
      } else {
        // Determine which part of the user object to update
        await axios.put(
          `https://webback.opencurtainscasting.com/${editField?.api}/${editField?.field}/${id}`,
          { [editField.apiField]: editField.value },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        // Update the appropriate part of the user object
        if (editField.api === 'director') {
          setUser((prevUser) => ({
            ...prevUser,
            result: {
              ...prevUser.result,
              [editField.apiField]: editField.value,
            },
          }));
        } else {
          setUser((prevUser) => ({
            ...prevUser,
            registerResult: {
              ...prevUser.registerResult,
              [editField.apiField]: editField.value,
            },
          }));
        }
      }

      // Toggle render state to ensure component re-renders with new data
      setRender(!render);
      setOpen(false);
    } catch (error) {
      console.error('Error updating the user data:', error);
    }
  };
  const DeleteUserDirector = async (userId) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `Are you sure want to delete this Crew`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, continue',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(
          `https://webback.opencurtainscasting.com/crew/deleteCrew/${userId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setRender(!render);
        Swal.fire('Success', 'User status updated successfully', 'success');
      } catch (error) {
        Swal.fire(
          'Error',
          'There was an error updating the user status',
          'error'
        );
      }
    } else {
      Swal.fire('Canceled', 'The action has been canceled.', 'info');
    }
  };

  if (!user) {
    return <Typography>Loading...</Typography>;
  }

  const { result, registerResult } = user;

  return (
    <Box m='20px' height='80vh' overflow='auto' paddingRight='20px'>
      <Header
        title={`VIEW DIRECTOR ID ${id}`}
        subtitle='View Director Details'
      />

      <Grid container spacing={2} pl={2} sx={{ fontSize: '1.0rem' }}>
        {/* Image */}
        <Grid item xs={2}>
          <Typography variant='h6' fontSize='1.0rem'>
            Image
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          {result?.imageURL ? (
            <img
              src={result?.imageURL}
              alt={`${registerResult?.firstName} ${registerResult?.lastName}`}
              style={{ width: '150px', height: 'auto', borderRadius: '50%' }}
            />
          ) : (
            <Typography fontSize='1.0rem'>No image available</Typography>
          )}
          <IconButton
            sx={{ color: '#6e0506', mt: '-100px', ml: '0px' }}
            onClick={() =>
              handleEditClick(
                'director',
                'updateUserImage',
                `imageURL`,
                '',
                'image'
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>
        <Grid item xs={2}>
          <Typography variant='h6' fontSize='1.0rem'>
            Slider Images
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            flexWrap: 'wrap',
          }}
        >
          {(() => {
            try {
              const imagesArray = registerResult?.images
                ? JSON.parse(registerResult.images)
                : [];

              if (imagesArray.length > 0) {
                return imagesArray
                  .slice(0, 4)
                  .map((image, index) => (
                    <img
                      key={index}
                      src={image}
                      alt={`${registerResult?.firstName} ${registerResult?.lastName}`}
                      style={{ width: '100px', height: 'auto', margin: '5px' }}
                    />
                  ));
              }
              return (
                <Typography fontSize='1.0rem'>No images available</Typography>
              );
            } catch (error) {
              console.error('Error parsing images:', error);
              return (
                <Typography fontSize='1.0rem'>
                  Error displaying images
                </Typography>
              );
            }
          })()}
          <IconButton
            sx={{ color: '#6e0506', mt: '-100px', ml: '0px' }}
            onClick={() =>
              handleEditClick(
                'user',
                'updateUserImages',
                'images',
                '',
                'image',
                [],
                true
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>
        {/* Full Name */}
        <Grid item xs={2}>
          <Typography variant='h6' fontSize='1.0rem'>
            Full Name
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>{`${registerResult?.firstName} ${registerResult?.lastName}`}</Typography>
          <IconButton
            sx={{ color: '#6e0506', mt: '-10px', ml: '20px' }}
            onClick={() =>
              handleEditClick(
                'user',
                'fullName',
                'fullName',
                `${registerResult?.firstName} ${registerResult?.lastName}`
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>

        {/* Email */}
        <Grid item xs={2}>
          <Typography variant='h6' fontSize='1.0rem'>
            Email
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>{registerResult?.email}</Typography>
          <IconButton
            sx={{ color: '#6e0506', mt: '-10px', ml: '20px' }}
            onClick={() =>
              handleEditClick(
                'user',
                'email',
                'updateEmail',
                `${registerResult?.email}`
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>

        {/* User Role */}
        <Grid item xs={2}>
          <Typography variant='h6' fontSize='1.0rem'>
            User Role
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>{registerResult?.role}</Typography>
          <IconButton
            sx={{ color: '#6e0506', mt: '-10px', ml: '20px' }}
            onClick={() =>
              handleEditClick(
                'user',
                'role',
                'updateRole',
                `${registerResult?.role}`,
                'dropdown',
                ['director', 'actor', 'crew']
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>

        {/* Contact Number */}
        <Grid item xs={2}>
          <Typography variant='h6' fontSize='1.0rem'>
            Contact Number
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>
            {registerResult?.contactNumber}
          </Typography>
          <IconButton
            sx={{ color: '#6e0506', mt: '-10px', ml: '20px' }}
            onClick={() =>
              handleEditClick(
                'user',
                'contactNumber',
                'updateContactNumber',
                `${registerResult?.contactNumber}`,
                'text'
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>

        {/* Birthday */}
        <Grid item xs={2}>
          <Typography variant='h6' fontSize='1.0rem'>
            Birthday
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>
            {registerResult?.birthday || 'Not provided'}
          </Typography>
          <IconButton
            sx={{ color: '#6e0506', mt: '-10px', ml: '20px' }}
            onClick={() =>
              handleEditClick(
                'user',
                'birthday',
                'updateBirthday',
                `${registerResult?.birthday}`,
                'text'
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>

        {/* Gender */}
        <Grid item xs={2}>
          <Typography variant='h6' fontSize='1.0rem'>
            Gender
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>
            {registerResult?.gender || 'Not provided'}
          </Typography>
          <IconButton
            sx={{ color: '#6e0506', mt: '-10px', ml: '20px' }}
            onClick={() =>
              handleEditClick(
                'user',
                'gender',
                'updateGender',
                `${registerResult?.gender}`,
                'dropdown',
                ['Male', 'Female', 'Non-Binary', 'Transgender']
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>

        {/* Location */}
        <Grid item xs={2}>
          <Typography variant='h6' fontSize='1.0rem'>
            Location
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>
            {result?.location || 'Not provided'}
          </Typography>
          <IconButton
            sx={{ color: '#6e0506', mt: '-10px', ml: '20px' }}
            onClick={() =>
              handleEditClick(
                'director',
                'location',
                'updateLocation',
                `${result?.location}`,
                'text'
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>

        {/* Social Links */}
        {/* {['Facebook', 'Instagram', 'TikTok', 'YouTube']?.map((platform) => (
          <React.Fragment key={platform}>
            <Grid item xs={2}>
              <Typography variant='h6' fontSize='1.0rem'>
                {platform} Link
              </Typography>
            </Grid>
            <Grid
              item
              xs={10}
              sx={{
                display: 'flex',
                alignItems: 'center',
                position: 'relative',
              }}
            >
              <Typography fontSize='1.0rem'>
                {result&&result[`${platform?.toLowerCase()}Link`] || 'Not provided'}
              </Typography>
            </Grid>
          </React.Fragment>
        ))} */}
        {['Facebook', 'Instagram', 'TikTok', 'YouTube', 'X']?.map(
          (platform) => {
            // Helper function to get correct endpoint name
            const getEndpointName = (platform) => {
              switch (platform) {
                case 'Facebook':
                  return 'updateFbLink';
                case 'Instagram':
                  return 'updateInstagram'; // Different pattern for Instagram
                case 'TikTok':
                  return 'updateTikTokLink';
                case 'YouTube':
                  return 'updateYoutubeLink';
                case 'X':
                  return 'updateXLink';
                default:
                  return '';
              }
            };

            return (
              <React.Fragment key={platform}>
                <Grid item xs={2}>
                  <Typography variant='h6' fontSize='1.0rem'>
                    {platform} Link
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={10}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    position: 'relative',
                  }}
                >
                  <Typography fontSize='1.0rem'>
                    {(result && result[`${platform.toLowerCase()}Link`]) ||
                      'Not provided'}
                  </Typography>
                  <IconButton
                    sx={{ color: '#6e0506', mt: '-10px', ml: '20px' }}
                    onClick={() =>
                      handleEditClick(
                        'director',
                        `${platform.toLowerCase()}Link`,
                        getEndpointName(platform),
                        result?.[`${platform.toLowerCase()}Link`] || '',
                        'text'
                      )
                    }
                  >
                    <EditIcon />
                  </IconButton>
                </Grid>
              </React.Fragment>
            );
          }
        )}

        {/* Created At */}
        <Grid item xs={2}>
          <Typography variant='h6' fontSize='1.0rem'>
            Created At
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>
            {new Date(result?.createdAt).toLocaleString()}
          </Typography>
        </Grid>

        {/* Updated At */}
        <Grid item xs={2}>
          <Typography variant='h6' fontSize='1.0rem'>
            Updated At
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>
            {new Date(result?.updatedAt).toLocaleString()}
          </Typography>
        </Grid>

        {/* Admin Active */}
        <Grid item xs={2}>
          <Typography variant='h6' fontSize='1.0rem'>
            Admin Active
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>
            {registerResult?.adminActive ? 'Activated' : 'Deactivated'}
          </Typography>
        </Grid>

        {/* User Active */}
        <Grid item xs={2}>
          <Typography variant='h6' fontSize='1.0rem'>
            User Active
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>
            {registerResult?.userActive ? 'Activated' : 'Deactivated'}
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            borderRadius: '4px',
            mb: '50px',
          }}
        >
          <IconButton
            sx={{ color: '#6e0506', borderRadius: '4px' }}
            onClick={() => DeleteUserDirector(id)}
          >
            <Delete />
            <Typography fontSize='1.0rem'>Delete Actor</Typography>
          </IconButton>
        </Grid>
      </Grid>
      <Modal
        sx={{ color: '#6e0506' }}
        open={open}
        onClose={() => setOpen(false)}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant='h6' mb={2}>
            Edit {editField.field}
          </Typography>
          {editField.type === 'text' && (
            <TextField
              fullWidth
              label={`Enter new ${editField.field}`}
              value={editField.value}
              onChange={(e) =>
                setEditField({ ...editField, value: e.target.value })
              }
            />
          )}
          {editField.type === 'date' && (
            <input
              style={{
                width: '100%',
                border: '1px solid #ccc',
                borderRadius: '4px',
                padding: '10px',
              }}
              type='date'
              value={editField.value}
              onChange={(e) =>
                setEditField({ ...editField, value: e.target.value })
              }
            />
          )}
          {editField.type === 'dropdown' && (
            <Select
              fullWidth
              value={editField.value}
              onChange={(e) =>
                setEditField({ ...editField, value: e.target.value })
              }
            >
              {editField.options.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          )}
          {editField.type === 'image' && (
            <input
              type='file'
              accept='image/*'
              multiple
              onChange={(e) =>
                setEditField({
                  ...editField,
                  value:
                    editField.field === 'images'
                      ? e.target.files
                      : e.target.files[0],
                })
              }
              style={{
                width: '100%',
                marginTop: '10px',
              }}
            />
          )}
          <Box mt={2} display='flex' justifyContent='flex-end'>
            <Button onClick={() => setOpen(false)} sx={{ mr: 2 }}>
              Cancel
            </Button>
            <Button
              variant='contained'
              sx={{
                bgcolor: '#6e0506',
                '&:hover': {
                  bgcolor: '#6e0506',
                },
              }}
              onClick={handleSave}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default ViewDirector;
